import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { tap } from "rxjs";
import { LogService } from "./log.service";
import { environment } from "src/environments/environment";
import { B4UService } from "./b4u.service";


export const ApiInterceptorService: HttpInterceptorFn = (req, next) => {
    const _logService = inject(LogService);
    const _b4UService = inject(B4UService);
    const trueEnvironment = _b4UService.getTrueEnvironmentDevOnly();
    const requestSize = req.body ? new Blob([JSON.stringify(req.body)]).size : 0; // Calculate request size in bytes
    // Extract custom headers
    const serviceName = req.headers.get('X-Service-Name') || 'UnknownService';
    const functionName = req.headers.get('X-Function-Name') || 'UnknownFunction';
    const skipLogging = req.headers.get('X-Skip-Logging') === 'true';
    const zoneType = req.headers.get('X-Zone-Type') || undefined;



    // Remove custom headers
    const modifiedHeaders = req.headers
        .delete('X-Service-Name')
        .delete('X-Function-Name')
        .delete('X-Skip-Logging')
        .delete('X-Zone-Type');
    const modifiedRequest = req.clone({ headers: modifiedHeaders });
    const requestTime = performance.now();
    return next(modifiedRequest).pipe(
        tap({
            next: (event) => {
                if (event instanceof HttpResponse) {
                    const duration = performance.now() - requestTime;
                    if (!skipLogging) {
                    setTimeout(() => {
                        _logService.logApi({
                            method: req.method,
                            uri: req.url,
                            response_time: duration,
                            response_code: event.status,
                            request_size: requestSize,
                            service_name: serviceName,
                            function_name: functionName,
                            environment: trueEnvironment,
                            ...(zoneType && { zone_type: zoneType }),
                        });
                    });
                    }
                }
            },
            error: (error: HttpErrorResponse) => {
                const duration = performance.now() - requestTime;
                // Extract error stack if available
                const errorStack = error.error?.stack || 'No stack trace available';
                const errorMessage = error.message ||  error.error?.message || "No Error message available"
                if (!skipLogging) {
                setTimeout(() => {
                    _logService.logApi({
                        method: req.method,
                        uri: req.url,
                        response_time: duration,
                        response_code: error.status,
                        request_size: requestSize,
                        service_name: serviceName,
                        function_name: functionName,
                        error_stack: errorStack, // Log the error stack
                        error_message: errorMessage,
                        environment: trueEnvironment,
                        ...(zoneType && { zone_type: zoneType }),
                    });
                });
                }
            }
        })
    );

}